import clsx from "clsx";
import { forwardRef, ImgHTMLAttributes } from "react";
import classes from "./image.module.css";

export type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  showShimmer?: boolean;
  shimmerClassName?: string;
};

export const Image = forwardRef<HTMLImageElement, ImageProps>(
  (
    {
      loading = "lazy",
      alt,
      sizes = "auto",
      className,
      showShimmer = true,
      shimmerClassName = "shimmer",
      ...props
    },
    ref,
  ) => {
    return (
      <img
        ref={ref}
        className={clsx(
          classes.root,
          className,
          showShimmer && shimmerClassName,
        )}
        loading={loading}
        sizes={sizes}
        alt={alt}
        {...props}
      />
    );
  },
);

Image.displayName = "Image";
